export const amenityOptions = [
  { value: "meeting", label: "Furnished conference room use" },
  { value: "kitchen", label: "Kitchen" },
  { value: "copy", label: "Copy/fax/printer/scanner use" },
  { value: "receptionist", label: "Receptionist/Answering" },
];

export const facilityOptions = [
  { value: "cam", label: "Common area maintenance" },
  { value: "furnished", label: "Furniture and furnishings" },
  { value: "janitorial", label: "Janitorial" },
  { value: "parking", label: "Parking" },
  { value: "tax", label: "Property insurance and taxes" },
];

export const propertyOptions = [
  { value: "Office", label: "Office" },
  { value: "Industrial/Warehouse", label: "Industrial/Warehouse" },
  { value: "Retail", label: "Retail" },
  // { value: "Flex", label: "Flex" },
  // { value: "Medical", label: "Medical" },
  { value: "Mixed/Other", label: "Mixed/Other" },
];

export const settingOptions = [
  { value: "Interior", label: "Interior" },
  { value: "Window", label: "Exterior/Window" },
];

export const spaceOptions = [
  { value: "Private office", label: "Private office(s)" },
  { value: "cubicle", label: "Cubicle(s)/Other" },
];

export const termOptions = [
  { value: "Month-to-month", label: "Month-to-month" },
  { value: "1-3", label: "1-3 months" },
  { value: "4-6", label: "4-6 months" },
  { value: "7-9", label: "7-9 months" },
  { value: "10-12", label: "10-12 months" },
  { value: "13-18", label: "13-18 months" },
  { value: ">18", label: "More than 18 months" },
  { value: "N/A", label: "N/A" },
];

export const utilityOptions = [
  { value: "electricity", label: "Electricity" },
  { value: "gas", label: "Gas/Oil/Propane" },
  { value: "water", label: "Water" },
  { value: "phone", label: "Phone" },
  { value: "internet", label: "Internet/WiFi" },
];

export const stateOptions = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District Of Columbia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];
